import type { DeviceMetricModule } from '../../collection/metrics/types';
import { defaultField, fieldPresentation, metricPresentation, recordingKind, recordKindLabel } from './presentation';
import { measurementContext } from './relationships';
import { metricCategories } from '../../collection/metrics/categories';

export const fitbitMetricModule: DeviceMetricModule = {
  id: 'fitbit', label: 'Fitbit',
  categories: metricCategories,
  defaultField, fieldPresentation, metricPresentation, recordingKind, recordKindLabel, measurementContext,
};
